import Datepicker from "vuejs-datepicker"
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
	name: 'DateEditor',
	props: {
		value: {
			type: Object,
		},
		dateRange: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			ja
		}
	},
	components: {
		Datepicker
	},
	template: `
		<div class="date-list-editor-date-inner">
			<Datepicker v-model="value.date"
				format="yyyy-MM-dd"
				class="date-list-editor-date-date"
				input-class="form-control"
				:typeable="true"
				:clear-button="true"
				:language="ja"
				@input="$emit('dateInput')"
			/>
			<span v-if="dateRange" class="from">～</span>
			<Datepicker v-if="dateRange"
				v-model="value.date_to"
				format="yyyy-MM-dd"
				class="date-list-editor-date-date"
				input-class="form-control"
				:typeable="true"
				:clear-button="true"
				:language="ja"
				@input="$emit('dateToInput')"
			/>
			<div class="date-list-editor-date-time">
				<input type="time" v-model="value.time_from"
					class="form-control time-input" size="8"
					@blur="$emit('timeFromInput')">
				<span class="from">～</span>
				<input type="time" v-model="value.time_to"
					class="form-control time-input" size="8"
					@blur="$emit('timeToInput')">
			</div>
		</div>
	`
}
